export enum Languages {
  ENGLISH = "en",
  ENGLISH_FULL_NAME = "English",
  ARABIC = "ar",
  ARABIC_FULL_NAME = "العربية",
}
